<template>
</template>

<script>
  export default {
    name: 'Logout',
    methods: {
      logout: function () {

      }
    },
    mounted: function () {
      // this.logout()
      this.$store.dispatch('signOut').then(() => {
        this.$router.push({ path: '/' })
      }).catch((err) => {
        this.$raven.captureException(err)
        this.$router.push({ path: '/' })
      })
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/auth/Logout.vue?219d3e40